import React from "react";
import { Row } from "react-bootstrap";

import NotFoundSVG from "../assets/img/Not Found.svg";
import bannerImage from "../assets/img/color-sharp.png";
import BackButton from "../helpers/BackButton";

const NotFound = () => {

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `url(${bannerImage})`,
        backgroundPosition: "top center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <BackButton/>

      <Row
        className="align-items-center justify-content-center"
        style={{
          height: "80vh",
          margin: "4%",
        }}
      >
        <img
          src={NotFoundSVG}
          style={{
            background: "#fff",
            borderRadius: "30px",
            width: "80%",
            padding: "10%",
          }}
          alt="Not Found"
        />
      </Row>
    </div>
  );
};

export default NotFound;
